// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { BankWaypoint, BankWaypointT, verifyBankWaypoint } from "./bank-waypoint";
import { GroupWaypoint, GroupWaypointT, verifyGroupWaypoint } from "./group-waypoint";
import { Waypoint, WaypointT, verifyWaypoint } from "./waypoint";
import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * A building floor plan map with overlay configuration.
 */
export class Map implements flatbuffers.IUnpackableObject<MapT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): Map {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsMap(bb: flatbuffers.ByteBuffer, obj?: Map): Map {
    return (obj || new Map()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsMap(bb: flatbuffers.ByteBuffer, obj?: Map): Map {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new Map()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  id(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  orgId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  name(): string | null;
  name(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  name(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  offlineUrl(): string | null;
  offlineUrl(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  offlineUrl(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  createdAt(): string | null;
  createdAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  createdAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  updatedAt(): string | null;
  updatedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  updatedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  deletedAt(): string | null;
  deletedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  deletedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * Appended at end of table for `FlatBuffer` wire compatibility.
   */
  waypoints(index: number, obj?: Waypoint): Waypoint | null {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset
      ? (obj || new Waypoint()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  waypointsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Appended at end of table for `FlatBuffer` wire compatibility.
   */
  groupWaypoints(index: number, obj?: GroupWaypoint): GroupWaypoint | null {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset
      ? (obj || new GroupWaypoint()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  groupWaypointsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Appended at end of table for `FlatBuffer` wire compatibility.
   */
  bankWaypoints(index: number, obj?: BankWaypoint): BankWaypoint | null {
    const offset = this.bb!.__offset(this.bb_pos, 28);
    return offset
      ? (obj || new BankWaypoint()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  bankWaypointsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 28);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Appended at end of table for `FlatBuffer` wire compatibility.
   */
  mapImgUrl(): string | null;
  mapImgUrl(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  mapImgUrl(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 30);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * Appended at end of table for `FlatBuffer` wire compatibility.
   */
  hasDisplayView(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 32);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  /**
   * Appended at end of table for `FlatBuffer` wire compatibility. Replaces
   * the deprecated `start` field as the default/main map indicator.
   */
  isMain(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 34);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  static startMap(builder: flatbuffers.Builder) {
    builder.startObject(16);
  }

  static addId(builder: flatbuffers.Builder, idOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, idOffset, 0);
  }

  static addOrgId(builder: flatbuffers.Builder, orgIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, orgIdOffset, 0);
  }

  static addName(builder: flatbuffers.Builder, nameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, nameOffset, 0);
  }

  static addOfflineUrl(builder: flatbuffers.Builder, offlineUrlOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, offlineUrlOffset, 0);
  }

  static addCreatedAt(builder: flatbuffers.Builder, createdAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(7, createdAtOffset, 0);
  }

  static addUpdatedAt(builder: flatbuffers.Builder, updatedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(8, updatedAtOffset, 0);
  }

  static addDeletedAt(builder: flatbuffers.Builder, deletedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(9, deletedAtOffset, 0);
  }

  static addWaypoints(builder: flatbuffers.Builder, waypointsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(10, waypointsOffset, 0);
  }

  static createWaypointsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startWaypointsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addGroupWaypoints(builder: flatbuffers.Builder, groupWaypointsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(11, groupWaypointsOffset, 0);
  }

  static createGroupWaypointsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startGroupWaypointsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addBankWaypoints(builder: flatbuffers.Builder, bankWaypointsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(12, bankWaypointsOffset, 0);
  }

  static createBankWaypointsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startBankWaypointsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addMapImgUrl(builder: flatbuffers.Builder, mapImgUrlOffset: flatbuffers.Offset) {
    builder.addFieldOffset(13, mapImgUrlOffset, 0);
  }

  static addHasDisplayView(builder: flatbuffers.Builder, hasDisplayView: boolean) {
    builder.addFieldInt8(14, +hasDisplayView, +false);
  }

  static addIsMain(builder: flatbuffers.Builder, isMain: boolean) {
    builder.addFieldInt8(15, +isMain, +false);
  }

  static endMap(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  unpack(): MapT {
    return new MapT(
      this.id() !== null ? this.id()!.unpack() : null,
      this.orgId() !== null ? this.orgId()!.unpack() : null,
      this.name(),
      this.offlineUrl(),
      this.createdAt(),
      this.updatedAt(),
      this.deletedAt(),
      this.bb!.createObjList<Waypoint, WaypointT>(
        this.waypoints.bind(this),
        this.waypointsLength(),
      ),
      this.bb!.createObjList<GroupWaypoint, GroupWaypointT>(
        this.groupWaypoints.bind(this),
        this.groupWaypointsLength(),
      ),
      this.bb!.createObjList<BankWaypoint, BankWaypointT>(
        this.bankWaypoints.bind(this),
        this.bankWaypointsLength(),
      ),
      this.mapImgUrl(),
      this.hasDisplayView(),
      this.isMain(),
    );
  }

  unpackTo(_o: MapT): void {
    _o.id = this.id() !== null ? this.id()!.unpack() : null;
    _o.orgId = this.orgId() !== null ? this.orgId()!.unpack() : null;
    _o.name = this.name();
    _o.offlineUrl = this.offlineUrl();
    _o.createdAt = this.createdAt();
    _o.updatedAt = this.updatedAt();
    _o.deletedAt = this.deletedAt();
    _o.waypoints = this.bb!.createObjList<Waypoint, WaypointT>(
      this.waypoints.bind(this),
      this.waypointsLength(),
    );
    _o.groupWaypoints = this.bb!.createObjList<GroupWaypoint, GroupWaypointT>(
      this.groupWaypoints.bind(this),
      this.groupWaypointsLength(),
    );
    _o.bankWaypoints = this.bb!.createObjList<BankWaypoint, BankWaypointT>(
      this.bankWaypoints.bind(this),
      this.bankWaypointsLength(),
    );
    _o.mapImgUrl = this.mapImgUrl();
    _o.hasDisplayView = this.hasDisplayView();
    _o.isMain = this.isMain();
  }

  unpackFields(...fields: string[]): MapT {
    const t = new MapT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("id")) {
      t.id = this.id() !== null ? this.id()!.unpack() : null;
    }
    if (fieldSet.has("org_id")) {
      t.orgId = this.orgId() !== null ? this.orgId()!.unpack() : null;
    }
    if (fieldSet.has("name")) {
      t.name = this.name();
    }
    if (fieldSet.has("offline_url")) {
      t.offlineUrl = this.offlineUrl();
    }
    if (fieldSet.has("created_at")) {
      t.createdAt = this.createdAt();
    }
    if (fieldSet.has("updated_at")) {
      t.updatedAt = this.updatedAt();
    }
    if (fieldSet.has("deleted_at")) {
      t.deletedAt = this.deletedAt();
    }
    if (fieldSet.has("waypoints")) {
      t.waypoints = this.bb!.createObjList<Waypoint, WaypointT>(
        this.waypoints.bind(this),
        this.waypointsLength(),
      );
    }
    if (fieldSet.has("group_waypoints")) {
      t.groupWaypoints = this.bb!.createObjList<GroupWaypoint, GroupWaypointT>(
        this.groupWaypoints.bind(this),
        this.groupWaypointsLength(),
      );
    }
    if (fieldSet.has("bank_waypoints")) {
      t.bankWaypoints = this.bb!.createObjList<BankWaypoint, BankWaypointT>(
        this.bankWaypoints.bind(this),
        this.bankWaypointsLength(),
      );
    }
    if (fieldSet.has("map_img_url")) {
      t.mapImgUrl = this.mapImgUrl();
    }
    if (fieldSet.has("has_display_view")) {
      t.hasDisplayView = this.hasDisplayView();
    }
    if (fieldSet.has("is_main")) {
      t.isMain = this.isMain();
    }
    return t;
  }
}

export class MapT implements flatbuffers.IGeneratedObject {
  constructor(
    public id: UuidT | null = null,
    public orgId: UuidT | null = null,
    public name: string | Uint8Array | null = null,
    public offlineUrl: string | Uint8Array | null = null,
    public createdAt: string | Uint8Array | null = null,
    public updatedAt: string | Uint8Array | null = null,
    public deletedAt: string | Uint8Array | null = null,
    public waypoints: WaypointT[] = [],
    public groupWaypoints: GroupWaypointT[] = [],
    public bankWaypoints: BankWaypointT[] = [],
    public mapImgUrl: string | Uint8Array | null = null,
    public hasDisplayView: boolean = false,
    public isMain: boolean = false,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const id = this.id !== null ? this.id!.pack(builder) : 0;
    const orgId = this.orgId !== null ? this.orgId!.pack(builder) : 0;
    const name = this.name !== null ? builder.createString(this.name!) : 0;
    const offlineUrl = this.offlineUrl !== null ? builder.createString(this.offlineUrl!) : 0;
    const createdAt = this.createdAt !== null ? builder.createString(this.createdAt!) : 0;
    const updatedAt = this.updatedAt !== null ? builder.createString(this.updatedAt!) : 0;
    const deletedAt = this.deletedAt !== null ? builder.createString(this.deletedAt!) : 0;
    const waypoints = Map.createWaypointsVector(
      builder,
      builder.createObjectOffsetList(this.waypoints),
    );
    const groupWaypoints = Map.createGroupWaypointsVector(
      builder,
      builder.createObjectOffsetList(this.groupWaypoints),
    );
    const bankWaypoints = Map.createBankWaypointsVector(
      builder,
      builder.createObjectOffsetList(this.bankWaypoints),
    );
    const mapImgUrl = this.mapImgUrl !== null ? builder.createString(this.mapImgUrl!) : 0;

    Map.startMap(builder);
    Map.addId(builder, id);
    Map.addOrgId(builder, orgId);
    Map.addName(builder, name);
    Map.addOfflineUrl(builder, offlineUrl);
    Map.addCreatedAt(builder, createdAt);
    Map.addUpdatedAt(builder, updatedAt);
    Map.addDeletedAt(builder, deletedAt);
    Map.addWaypoints(builder, waypoints);
    Map.addGroupWaypoints(builder, groupWaypoints);
    Map.addBankWaypoints(builder, bankWaypoints);
    Map.addMapImgUrl(builder, mapImgUrl);
    Map.addHasDisplayView(builder, this.hasDisplayView);
    Map.addIsMain(builder, this.isMain);

    return Map.endMap(builder);
  }

  clone(): MapT {
    const obj = new MapT();
    obj.id = this.id !== null ? this.id!.clone() : null;
    obj.orgId = this.orgId !== null ? this.orgId!.clone() : null;
    obj.name = this.name;
    obj.offlineUrl = this.offlineUrl;
    obj.createdAt = this.createdAt;
    obj.updatedAt = this.updatedAt;
    obj.deletedAt = this.deletedAt;
    obj.waypoints = this.waypoints.map((e) => e.clone());
    obj.groupWaypoints = this.groupWaypoints.map((e) => e.clone());
    obj.bankWaypoints = this.bankWaypoints.map((e) => e.clone());
    obj.mapImgUrl = this.mapImgUrl;
    obj.hasDisplayView = this.hasDisplayView;
    obj.isMain = this.isMain;
    return obj;
  }

  equals(other: MapT): boolean {
    if (this.id !== null && other.id !== null) {
      if (!this.id!.equals(other.id!)) return false;
    } else if (this.id !== other.id) return false;
    if (this.orgId !== null && other.orgId !== null) {
      if (!this.orgId!.equals(other.orgId!)) return false;
    } else if (this.orgId !== other.orgId) return false;
    if (this.name !== other.name) return false;
    if (this.offlineUrl !== other.offlineUrl) return false;
    if (this.createdAt !== other.createdAt) return false;
    if (this.updatedAt !== other.updatedAt) return false;
    if (this.deletedAt !== other.deletedAt) return false;
    if (this.waypoints.length !== other.waypoints.length) return false;
    for (let i = 0; i < this.waypoints.length; i++) {
      const a = this.waypoints[i];
      const b = other.waypoints[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.groupWaypoints.length !== other.groupWaypoints.length) return false;
    for (let i = 0; i < this.groupWaypoints.length; i++) {
      const a = this.groupWaypoints[i];
      const b = other.groupWaypoints[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.bankWaypoints.length !== other.bankWaypoints.length) return false;
    for (let i = 0; i < this.bankWaypoints.length; i++) {
      const a = this.bankWaypoints[i];
      const b = other.bankWaypoints[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.mapImgUrl !== other.mapImgUrl) return false;
    if (this.hasDisplayView !== other.hasDisplayView) return false;
    if (this.isMain !== other.isMain) return false;
    return true;
  }
}

export function verifyMap(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 6);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 12);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 18);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 20);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 22);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 24);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyWaypoint);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 26);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyGroupWaypoint);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 28);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyBankWaypoint);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 30);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 32, 1);
    verifier.checkScalarField(tablePos, 34, 1);
  } finally {
    verifier.popDepth();
  }
}
